// src/parser/raster.ts
import { bandsOperation } from "../utils/bandOperation/bands";
import { extentToCoord, isNumberArray } from "../utils/util";
function raster(data, cfg) {
  const {
    extent = [121.168, 30.2828, 121.384, 30.4219],
    coordinates,
    width,
    height,
    min,
    max,
    format,
    operation
  } = cfg;
  let bandData;
  let rasterWidth;
  let rasterHeight;
  if (format === void 0 || isNumberArray(data)) {
    bandData = Array.from(data);
    rasterWidth = width;
    rasterHeight = height;
  } else {
    const imageDataList = Array.isArray(data) ? data : [data];
    bandData = bandsOperation(imageDataList, format, operation);
  }
  const imageCoord = extentToCoord(coordinates, extent);
  const resultData = {
    _id: 1,
    dataArray: [
      {
        _id: 1,
        data: bandData,
        width: rasterWidth,
        height: rasterHeight,
        min,
        max,
        coordinates: imageCoord
      }
    ]
  };
  return resultData;
}
export {
  raster as default
};
